/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type MigratedPoolHookConfig = {
  hookProgram: Address;
  hookFlags: number;
};

export type MigratedPoolHookConfigArgs = MigratedPoolHookConfig;

export function getMigratedPoolHookConfigEncoder(): FixedSizeEncoder<MigratedPoolHookConfigArgs> {
  return getStructEncoder([
    ['hookProgram', getAddressEncoder()],
    ['hookFlags', getU32Encoder()],
  ]);
}

export function getMigratedPoolHookConfigDecoder(): FixedSizeDecoder<MigratedPoolHookConfig> {
  return getStructDecoder([
    ['hookProgram', getAddressDecoder()],
    ['hookFlags', getU32Decoder()],
  ]);
}

export function getMigratedPoolHookConfigCodec(): FixedSizeCodec<
  MigratedPoolHookConfigArgs,
  MigratedPoolHookConfig
> {
  return combineCodec(
    getMigratedPoolHookConfigEncoder(),
    getMigratedPoolHookConfigDecoder(),
  );
}
